import { Text, TextButton, Timeline } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import React from 'react';
import { generalToolTips } from '../../../../bi/types';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { PageType } from '../types';
import { getCurrentLayoutName, getPageType, getRecommendedLayoutName } from '../utils/layout-utils';
export const LayoutElementTimeline = _ref => {
  let {
    element,
    elementIndex,
    status,
    handleRescanClick
  } = _ref;
  const biLogger = useBiLogger();
  const pageType = getPageType(element.widgetId);
  const currentLayoutName = getCurrentLayoutName(element.widgetId, element.layoutValue);
  const recommendedLayout = getRecommendedLayoutName(element.widgetId);
  const firstStep = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      textBold: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      })
    },
    i18nKey: pageType === PageType.Category ? 'accessibility-wizard.rules-list.inaccessible-layout.element.content.first-step.category-page' : 'accessibility-wizard.rules-list.inaccessible-layout.element.content.first-step.product-page',
    values: {
      pageType
    }
  }));
  const secondStep = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      boldText: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      })
    },
    i18nKey: pageType === PageType.Category ? 'accessibility-wizard.rules-list.inaccessible-layout.element.content.second-step.category-page' : 'accessibility-wizard.rules-list.inaccessible-layout.element.content.second-step.product-page',
    values: {
      currentLayoutName,
      recommendedLayoutName: recommendedLayout
    }
  }));
  const thirdStep = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      rescanButton: /*#__PURE__*/React.createElement(TextButton, {
        size: "tiny",
        skin: "dark",
        underline: "always",
        weight: "bold",
        onClick: () => {
          handleRescanClick(element.id);
          biLogger.taskElementCtaClick({
            ctaName: generalToolTips.rescanPage,
            index: elementIndex,
            status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
          });
        }
      })
    },
    i18nKey: "accessibility-wizard.rules-list.inaccessible-layout.element.content.third-step"
  }));
  const items = [{
    label: firstStep
  }, {
    label: secondStep
  }, {
    label: thirdStep
  }];
  return /*#__PURE__*/React.createElement(Timeline, {
    gap: "20px",
    items: items,
    skin: "dark"
  });
};
//# sourceMappingURL=layout-element-timeline.tsx.js.map